export const ATTENDEES_VIEW = 'Attendees';
export const RANDOMIZED_BREAKS_VIEW = 'Slots/Teams - Randomized Breaks';
export const SELLER_INFORMATION_VIEW = 'Seller Information';
export const ACTIVE_LINE_VIEW = 'Active Line';
export const LINE_HISTORY_VIEW = 'Line History';
export const AVAILABLE_PRODUCTS_VIEW = 'Available Product(s)';
export const PICK_YOUR_SLOTS_VIEW = 'Slots/Teams - Pick your slots';
export const LINKED_EVENTS_VIEW = 'Linked Events';
